import React, { CSSProperties } from "react";

const groupStyle = {
  border: "1px solid rgba(0,0,0,0.27)",
  borderRadius: "4px",
  width: "100%",
  padding: "10px",
  paddingTop: "6px",
  marginLeft: "7px",
  marginBottom: "3px",
};

const OutlinedDiv: React.FC<{style?: CSSProperties}> = ({ children, style }) =>
  <div style={{ ...groupStyle, ...(style || {}) }} >{children}</div>;

export default OutlinedDiv;
